import ModalAsientoContable from "features/Contabilidad/components/ModalAsientoContable/ModalAsientoContable"
import { useState } from "react"
import { useTranslation } from "react-i18next"

interface AsientoContableProps {
  id?: string
  numero?: number
}
export const ModalAsiento = ({
  asientoContable,
  refreshData,
}: {
  asientoContable: AsientoContableProps
  refreshData: () => void
}) => {
  const { t } = useTranslation()
  const [openModalAsiento, setOpenModalAsiento] = useState(false)

  return asientoContable?.id && asientoContable?.numero ? (
    <>
      <div className='tw-mt-3 tw-pt-2 tw-pb-2 tw-border-t-2'>
        <div className='tw-mb-2'>
          <h4 className='tw-font-medium tw-text-[#02223C] tw-text-base'>
            {t("documentos.modalAsiento.asientoTitle")}
          </h4>
        </div>
        <div className='tw-mb-2 tw-flex'>
          <div className='tw-w-1/2'>
            <span className='tw-mr-1'>
              {t("documentos.modalAsiento.asientoLabel")}
            </span>
            <span className='tw-font-medium'>{asientoContable?.numero}</span>
          </div>
          <div
            className='tw-w-1/2 tw-text-right tw-text-text-hyperlink tw-cursor-pointer hover:tw-underline'
            onClick={() => setOpenModalAsiento(true)}
          >
            {t("documentos.modalAsiento.asientoLink")}
          </div>
        </div>
      </div>
      <ModalAsientoContable
        idToEdit={asientoContable?.id}
        show={openModalAsiento}
        setShow={setOpenModalAsiento}
        updateTable={refreshData}
      />
    </>
  ) : null
}
